import React, { useMemo } from 'react';
import { IconContext, UserCircle } from '@mezzoforte/forge-icons';
import { LoggedInIcon } from '@/components/Header/UserGreeting/LoggedInIcon';
import { CompanyIcon } from '@/components/Header/UserGreeting/CompanyIcon';
import { useSession } from '@/hooks/useSession';
import { useCompanySelection } from '@/hooks/useCompanySelection';
import { useShouldShowCompanySelector } from '@/hooks/useShouldShowCompanySelector';

export function UserIcon() {
  const { shouldShowCompanySelector } = useShouldShowCompanySelector();
  const { selectedCompany } = useCompanySelection();
  const { currentUser } = useSession();
  const iconContextValue = useMemo(() => ({ size: 24 }), []);

  if (selectedCompany && shouldShowCompanySelector) {
    return <CompanyIcon company={selectedCompany} />;
  }

  if (currentUser.data?.isAuthenticated && currentUser.data.user.firstName && currentUser.data.user.lastName) {
    return (
      <LoggedInIcon
        initials={[currentUser.data.user.firstName, currentUser.data.user.lastName].map((word) => word[0]).join('')}
        background="brand"
      />
    );
  }

  return (
    <IconContext.Provider value={iconContextValue}>
      <UserCircle />
    </IconContext.Provider>
  );
}
